import type { Editor } from "@tiptap/react";
import { CheckSquare, List, ListOrdered } from "lucide-react";

export function DocumentFormatting({
  editor,
  disabled = false,
}: {
  editor: Editor | null;
  disabled?: boolean;
}) {
  return (
    <div
      className="document-format"
      aria-label="Document formatting"
      inert={disabled}
      onPointerDown={(event) => event.stopPropagation()}
      onMouseDown={(event) => event.preventDefault()}
    >
      <button
        type="button"
        onClick={() => editor?.chain().focus().setParagraph().run()}
      >
        Body
      </button>
      <button
        type="button"
        onClick={() =>
          editor?.chain().focus().toggleHeading({ level: 2 }).run()
        }
      >
        Heading
      </button>
      <span className="document-format-divider" />
      <button
        type="button"
        aria-label="Bold"
        onClick={() => editor?.chain().focus().toggleBold().run()}
      >
        <b>B</b>
      </button>
      <button
        type="button"
        aria-label="Italic"
        onClick={() => editor?.chain().focus().toggleItalic().run()}
      >
        <i>I</i>
      </button>
      <span className="document-format-divider" />
      <button
        type="button"
        aria-label="Bullets"
        title="Bulleted list"
        onClick={() => editor?.chain().focus().toggleBulletList().run()}
      >
        <List size={17} strokeWidth={1.5} />
      </button>
      <button
        type="button"
        aria-label="Numbers"
        title="Numbered list"
        onClick={() => editor?.chain().focus().toggleOrderedList().run()}
      >
        <ListOrdered size={17} strokeWidth={1.5} />
      </button>
      <button
        type="button"
        aria-label="Checklist"
        title="Checklist"
        onClick={() => editor?.chain().focus().toggleTaskList().run()}
      >
        <CheckSquare size={16} strokeWidth={1.5} />
      </button>
    </div>
  );
}
